<template>
  <div v-if="visible" class="cpbe-modal">
    <div class="cpbe-box">
      <header class="cpbe-head">
        <div class="cpbe-title-wrap">
          <span class="cpbe-accent"></span>
          <span class="cpbe-title">{{ title }}</span>
          <span class="cpbe-count">共 {{ count }} 件</span>
        </div>
        <button class="cpbe-close" type="button" @click="close">×</button>
      </header>
      <div class="cpbe-content">
        <div class="cpbe-main">
          <div class="gx-cloud__modal-body cpbe-body">
            <div class="gx-cloud__edit-box">
              <!-- 左侧：商品列表 -->
              <div class="gx-cloud__edit-left">
                <div class="gx-cloud__sku-filters" v-if="cloudEditMode === 'batch'">
                  <select
                    v-model="cloudEditGroupId"
                    class="gx-cloud__select"
                    @change="handleCloudEditFilterGroupChange">
                    <option value="">全部分组</option>
                    <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                  </select>
                  <select
                    v-model="cloudEditSkuStatus"
                    class="gx-cloud__select"
                    @change="handleCloudEditFilterChange">
                    <option value="">全部状态</option>
                    <option v-for="(v, k) in skuStatus" :key="k" :value="v.value">{{ v.label }}</option>
                  </select>
                  <select
                    v-model="cloudEditChildGroupId"
                    class="gx-cloud__select"
                    @change="handleCloudEditFilterChange">
                    <option value="">全部子分组</option>
                    <option v-for="g in cloudEditChildGroupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                  </select>
                  <select
                    v-model="cloudEditAppraisalStatus"
                    class="gx-cloud__select"
                    @change="handleCloudEditFilterChange">
                    <option value="">全部检测</option>
                    <option v-for="(v, k) in appraisal_status" :key="k" :value="v.value">{{ v.label }}</option>
                  </select>
                  <select
                    v-model="cloudEditSkuMarkStatus"
                    class="gx-cloud__select"
                    @change="handleCloudEditFilterChange">
                    <option value="">标记状态</option>
                    <option v-for="(v, k) in skuMarkStatus" :key="k" :value="v.value">{{ v.label }}</option>
                  </select>
                  <select
                    v-model="cloudEditSkuIsSkuMiss"
                    class="gx-cloud__select"
                    @change="handleCloudEditFilterChange">
                    <option value="">是否缺少sku图</option>
                    <option value="1">不缺sku图</option>
                    <option value="2">缺少sku图</option>
                  </select>
                </div>
                <div v-if="cloudEditMode === 'batch'" class="gx-cloud__edit-count">
                  编辑商品 {{ cloudEditList.length }}/{{
                    cloudEditUseRemoteList ? cloudEditPage.total : cloudEditSourceList.length
                  }}
                </div>
                <div class="gx-cloud__edit-products">
                  <div
                    v-for="item in cloudEditList"
                    :key="item.id"
                    class="gx-cloud__edit-item"
                    :class="{ 'gx-cloud__edit-item--on': cloudEditCurrent && cloudEditCurrent.id === item.id }"
                    @click="handleCloudEditSelect(item)">
                    <el-popover
                        placement="top"
                        :fallback-placements="[ 'top', 'right', 'left','bottom']"
                        width="350"
                        trigger="hover" :disabled="!item.main_image">
                      <div class="popover-content">
                        <el-image :src="item.main_image" fit="contain" style="width:100%;height: auto"></el-image>
                      </div>
                      <div class="gx-cloud__sku-thumb" slot="reference">
                        <img v-if="item.main_image" :src="item.main_image" alt="" />
                      </div>
                    </el-popover>
                    <div class="gx-cloud__edit-item-body">
                      <div class="gx-cloud__edit-item-title" :title="item.title">{{ item.title }}</div>
                      <div class="gx-cloud__edit-item-meta">
                        <span class="gx-cloud__gold">¥{{ item.price }}</span>
                        <span class="gx-cloud__dim">{{ item.updated_at_text }}</span>
                      </div>
                      <div class="gx-cloud__edit-item-meta text-gray" >来源商品ID：{{item.source_product_id}}</div>
                    </div>
                  </div>
                  <div v-if="!cloudEditList.length" class="gx-cloud__empty">暂无商品</div>
                </div>
                <div
                  v-if="cloudEditUseRemoteList && cloudEditPage.total > 0"
                  class="gx-cloud__pager gx-cloud__pager--sm">
                  <span class="gx-cloud__pager-total">共 {{ cloudEditPage.total }} 条</span>
                  <div class="gx-cloud__pager-btns">
                    <button
                      class="gx-cloud__page gx-cloud__page--arrow"
                      :disabled="cloudEditPage.page <= 1"
                      @click="loadCloudEditRemoteListPage(cloudEditPage.page - 1)">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M7.5 2.5L4 6l3.5 3.5"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>
                    <button
                      v-for="n in cloudEditPages"
                      :key="n"
                      class="gx-cloud__page"
                      :class="{ 'gx-cloud__page--on': n === cloudEditPage.page }"
                      @click="loadCloudEditRemoteListPage(n)">
                      {{ n }}
                    </button>
                    <button
                      class="gx-cloud__page gx-cloud__page--arrow"
                      :disabled="cloudEditPage.page >= cloudEditTotalPages"
                      @click="loadCloudEditRemoteListPage(cloudEditPage.page + 1)">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M4.5 2.5L8 6l-3.5 3.5"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <!-- 右侧：编辑表单 -->
              <div class="gx-cloud__edit-right">
                <div v-if="cloudEditForm.id">
                  <div
                    v-if="distributeRecordsLoading || distributeRecordsError || distributeRecords.length"
                    class="cpbe-distribute-records">
                    <div v-if="distributeRecordsLoading" class="cpbe-distribute-records-state">加载铺货记录...</div>
                    <div v-else-if="distributeRecordsError" class="cpbe-distribute-records-state">铺货记录加载失败</div>
                    <div
                      v-for="record in distributeRecords"
                      :key="record.id"
                      class="cpbe-distribute-record"
                      :class="'is-' + getDistributeRecordType(record)">
                      <div class="cpbe-distribute-record-status">
                        {{ getDistributeRecordIcon(record) }}
                        {{ record.distribute_status_text || record.platform_status_text || '铺货记录' }}
                      </div>
                      <div class="cpbe-distribute-record-grid">
                        <span>铺货时间：{{ record.created_at_text || record.updated_at_text || '-' }}</span>
                        <span>铺货店铺：{{ record.shop_name || record.mer_shop_id || '-' }}</span>
                        <span>铺货平台：{{ record.shop_type_text || '-' }}</span>
                        <span>平台ID：{{ record.platform_product_id || '-' }}</span>
                      </div>
                      <div v-if="record.error_msg" class="cpbe-distribute-record-reason">
                        失败原因：{{ record.error_msg }}
                      </div>
                    </div>
                  </div>
                  <div class="gx-cloud__field cpbe-title-card">
                    <label class="gx-cloud__label">
                      商品标题
                      <i class="gx-cloud__req">*</i>
                    </label>
                    <input
                      v-model="cloudEditForm.title"
                      class="gx-cloud__input gx-cloud__input--full"
                      maxlength="120"
                      placeholder="请输入商品标题"
                      @input="markCloudEditDirty" />
                    <div class="gx-cloud__tips">{{ (cloudEditForm.title || '').length }}/30</div>
                  </div>
                  <div class="gx-cloud__field cpbe-title-card">
                    <label class="gx-cloud__label">
                      商品短标题
                    </label>
                    <input
                      v-model="cloudEditForm.short_title"
                      class="gx-cloud__input gx-cloud__input--full"
                      maxlength="24"
                      placeholder="请输入商品短标题"
                      @input="handleShortTitleInput" />
                    <div class="gx-cloud__tips">{{ getShortTitleByteLength(cloudEditForm.short_title || '') }}/12</div>
                  </div>
                  <div class="cpbe-section" :class="{ 'cpbe-section--open': sectionOpen.mainImage }">
                    <button type="button" class="cpbe-section-head" @click="toggleSection('mainImage')">
                      <span class="cpbe-section-icon">🖼</span>
                      <span>主图</span>
                      <i class="cpbe-section-arrow el-icon-arrow-down"></i>
                    </button>
                    <div v-show="sectionOpen.mainImage" class="cpbe-section-body">
                      <div class="gx-cloud__field">
                        <!-- <label class="gx-cloud__label">商品图片 <i class="gx-cloud__req">*</i></label> -->
                        <div class="gx-cloud__edit-imgbar">
                          <span
                            class="gx-cloud__dim"
                            :class="{ 'gx-cloud__invalid': cloudEditForm.main_images.length < 3 }">
                            至少3张，当前
                            {{ cloudEditForm.main_images.length }} 张，最多8张，不能上传一样的图片。（第一张为主图）
                          </span>
                        </div>
                        <div class="gx-cloud__imgs">
                          <div
                            v-for="(url, i) in cloudEditForm.main_images"
                            :key="'m' + i"
                            class="gx-cloud__img gx-cloud__img--lg cpbe-main-image">
                            <img :src="url" alt="" @click="previewImage(url)" />
                            <div class="gx-cloud__img-tools">
                              <button
                                type="button"
                                class="gx-cloud__img-tool"
                                @click="moveCloudEditImage('main', i, -1)">
                                <i class="el-icon-arrow-left"></i>
                              </button>
                              <button
                                type="button"
                                class="gx-cloud__img-tool"
                                @click="moveCloudEditImage('main', i, 1)">
                                <i class="el-icon-arrow-right"></i>
                              </button>
                              <button type="button" class="gx-cloud__img-tool" @click="removeCloudEditImage('main', i)">
                                <i class="el-icon-delete"></i>
                              </button>
                            </div>
                          </div>
                          <button
                            v-if="cloudEditForm.main_images.length < 8"
                            type="button"
                            class="cpbe-upload-tile"
                            @click="openImageSourceDialog('main')">
                            <span class="cpbe-upload-plus">＋</span>
                            <span>上传</span>
                            <span>建议尺寸800×800</span>
                          </button>
                        </div>
                        <!-- <div>
                          <span class="gx-cloud__dim">建议尺寸 800×800 · 最多8张</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="cpbe-section cpbe-sku-editor" :class="{ 'cpbe-section--open': sectionOpen.sku }">
                    <button type="button" class="cpbe-section-head" @click="toggleSection('sku')">
                      <span class="cpbe-section-icon">🧩</span>
                      <span>SKU</span>
                      <i class="cpbe-section-arrow el-icon-arrow-down"></i>
                    </button>
                    <div v-show="sectionOpen.sku" class="cpbe-section-body">
                      <div class="gx-cloud__field">
                        <div v-for="(spec, si) in cloudEditForm.skuSpecs" :key="si" class="cpbe-sku-row">
                          <span class="cpbe-sku-name">{{ spec.name || spec.key || '规格' }}</span>
                          <div class="cpbe-sku-values">
                            <span v-for="(v, vi) in spec.values" :key="vi" class="cpbe-sku-value-wrap">
                              <span v-if="si === 0 && hasSkuAttributeValues" class="cpbe-sku-value-image">
                                <img
                                  v-if="getSkuValueImage(si, vi, v)"
                                  :src="getSkuValueImage(si, vi, v)"
                                  alt=""
                                  @click="previewImage(getSkuValueImage(si, vi, v))" />
                                <span v-else class="cpbe-sku-value-image-empty">+</span>
                                <span class="cpbe-sku-value-image-tools">
                                  <button type="button" @click.stop="openImageSourceDialog('skuValue', v)">
                                    <i class="el-icon-refresh"></i>
                                  </button>
                                  <button type="button" @click.stop="clearSkuValueImage(v)">
                                    <i class="el-icon-delete"></i>
                                  </button>
                                </span>
                              </span>
                              <input
                                :value="v"
                                :title="v"
                                class="cpbe-sku-value-input"
                                @input="handleSkuValueChange(si, vi, $event.target.value)" />
                              <button type="button" class="cpbe-sku-value-remove" @click="removeSkuSpecValue(si, vi)">
                                <i class="el-icon-delete"></i>
                              </button>
                            </span>
                            <button type="button" class="cpbe-sku-add-btn" @click="addSkuValueForSpec(si)">
                              ＋ 添加
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="section in extraSections"
                    :key="section.key"
                    class="cpbe-section"
                    :class="{ 'cpbe-section--open': sectionOpen[section.key] }">
                    <button type="button" class="cpbe-section-head" @click="toggleSection(section.key)">
                      <span class="cpbe-section-icon">{{ section.icon }}</span>
                      <span>{{ section.label }}</span>
                      <i class="cpbe-section-arrow el-icon-arrow-down"></i>
                    </button>
                    <div v-show="sectionOpen[section.key]" class="cpbe-section-body">
                      <div v-if="section.key === 'ratioImage'" class="gx-cloud__imgs">
                        <div class="gx-cloud__edit-imgbar">
                          <span class="gx-cloud__dim">最多5张，图片宽高比必须为3:4（当前 {{ cloudEditForm.three_four_images.length }} 张）</span>
                        </div>
                        <div
                          v-for="(url, i) in cloudEditForm.three_four_images"
                          :key="i"
                          class="gx-cloud__img gx-cloud__img--lg cpbe-main-image">
                          <img :src="url" alt="" @click="previewImage(url)" />
                          <div class="gx-cloud__img-tools">
                            <button
                              type="button"
                              class="gx-cloud__img-tool"
                              @click="moveCloudEditImage('ratio', i, -1)">
                              <i class="el-icon-arrow-left"></i>
                            </button>
                            <button type="button" class="gx-cloud__img-tool" @click="moveCloudEditImage('ratio', i, 1)">
                              <i class="el-icon-arrow-right"></i>
                            </button>
                            <button type="button" class="gx-cloud__img-tool" @click="removeCloudEditImage('ratio', i)">
                              <i class="el-icon-delete"></i>
                            </button>
                          </div>
                        </div>
                        <button
                          v-if="cloudEditForm.three_four_images.length < 5"
                          type="button"
                          class="cpbe-upload-tile"
                          @click="openImageSourceDialog('ratio')">
                          <span class="cpbe-upload-plus">＋</span>
                          <span>上传</span>
                        </button>
                      </div>
                      <div v-else-if="section.key === 'whiteImage'" class="gx-cloud__imgs">
                        <div class="gx-cloud__edit-imgbar">
                          <span class="gx-cloud__dim">最多1张，图片宽高比必须为1:1（当前 {{ cloudEditForm.white_images.length }} 张）</span>
                        </div>
                        <div
                          v-for="(url, i) in cloudEditForm.white_images"
                          :key="i"
                          class="gx-cloud__img gx-cloud__img--lg cpbe-main-image">
                          <img :src="url" alt="" @click="previewImage(url)" />
                          <div class="gx-cloud__img-tools">
                            <button
                              type="button"
                              class="gx-cloud__img-tool"
                              @click="moveCloudEditImage('white', i, -1)">
                              <i class="el-icon-arrow-left"></i>
                            </button>
                            <button type="button" class="gx-cloud__img-tool" @click="moveCloudEditImage('white', i, 1)">
                              <i class="el-icon-arrow-right"></i>
                            </button>
                            <button type="button" class="gx-cloud__img-tool" @click="removeCloudEditImage('white', i)">
                              <i class="el-icon-delete"></i>
                            </button>
                          </div>
                        </div>
                        <button
                          v-if="cloudEditForm.white_images.length < 1"
                          type="button"
                          class="cpbe-upload-tile"
                          @click="openImageSourceDialog('white')">
                          <span class="cpbe-upload-plus">＋</span>
                          <span>上传</span>
                        </button>
                      </div>
                      <div v-else-if="section.key === 'specSku'" class="cpbe-specsku-list">
<!--                        <div class="cpbe-specsku-batch">-->
<!--                          <span class="cpbe-batch-caption">SKU分类</span>-->
<!--                          <el-select-->
<!--                            v-model="batchSkuCategories"-->
<!--                            class="cpbe-batch-category-select"-->
<!--                            multiple-->
<!--                            collapse-tags-->
<!--                            size="mini"-->
<!--                            clearable-->
<!--                            placeholder="全部 SKU"-->
<!--                            :title="batchSkuCategories.join(', ') || '未选择时修改全部 SKU'">-->
<!--                            <el-option-->
<!--                              v-for="value in batchSkuCategoryOptions"-->
<!--                              :key="value"-->
<!--                              :label="value"-->
<!--                              :value="value" />-->
<!--                          </el-select>-->
<!--                          <div v-for="field in batchSkuFieldOptions" :key="field.key" class="cpbe-batch-field">-->
<!--                            <label>-->
<!--                              <input v-model="batchSkuFields[field.key]" type="checkbox" />-->
<!--                              {{ field.label }}-->
<!--                            </label>-->
<!--                            <input-->
<!--                              v-model="batchSkuValues[field.key]"-->
<!--                              :type="field.type"-->
<!--                              :step="field.key === 'price' ? '0.01' : undefined"-->
<!--                              @input="batchSkuFields[field.key] = true"-->
<!--                              :placeholder="field.placeholder"-->
<!--                              class="gx-cloud__input" />-->
<!--                          </div>-->
<!--                          <button-->
<!--                            type="button"-->
<!--                            class="cpbe-batch-apply"-->
<!--                            :disabled="!canApplySkuBatch"-->
<!--                            @click="applySkuBatch">-->
<!--                            一键填写-->
<!--                          </button>-->
<!--                        </div>-->
                        <div
                          v-for="(sku, skuIndex) in cloudEditForm.skus"
                          :key="sku.id || getSkuAttributesKey(sku.attributes)"
                          class="cpbe-specsku-card">
                          <span class="cpbe-specsku-index">{{ skuIndex + 1 }}</span>
                          <div class="cpbe-sku-preview-wrap">
                            <img
                              v-if="getSkuPreviewImage(sku)"
                              :src="getSkuPreviewImage(sku)"
                              class="cpbe-sku-preview"
                              alt=""
                              @click="previewImage(getSkuPreviewImage(sku))" />
                            <span v-else class="cpbe-sku-preview-empty">—</span>
                          </div>
                          <div class="cpbe-specsku-info">
                            <strong>{{ formatSkuAttributes(sku.attributes) }}</strong>
                            <div class="cpbe-specsku-fields-row">
                              <label>价格</label>
                              <input
                                v-model="sku.price"
                                class="gx-cloud__input cpbe-specsku-num"
                                type="number"
                                placeholder="价格"
                                :disabled="!sku.enabled"
                                @input="markCloudEditDirty" />
                              <label>库存</label>
                              <input
                                v-model="sku.stock"
                                class="gx-cloud__input cpbe-specsku-num"
                                type="number"
                                placeholder="库存"
                                :disabled="!sku.enabled"
                                @input="markCloudEditDirty" />
                              <label>SKU编码</label>
                              <input
                                v-model="sku.code"
                                class="gx-cloud__input cpbe-specsku-code"
                                placeholder="SKU编码"
                                @input="markCloudEditDirty" />
                            </div>
                            <!-- <div class="cpbe-specsku-fields-row cpbe-specsku-text-row">
                              <input v-model="sku.description" class="gx-cloud__input cpbe-specsku-description"
                                placeholder="规格文字描述" @input="markCloudEditDirty" />

                            </div> -->
                          </div>
                        </div>
                        <div v-if="!cloudEditForm.skus.length" class="cpbe-placeholder">暂无规格 SKU</div>
                      </div>
                      <div v-else-if="section.key === 'attributes'" class="cpbe-attributes-editor">
                        <div v-if="attributesLoading" class="cpbe-placeholder">加载中...</div>
                        <template v-else>
                          <div v-for="(item, i) in cloudEditForm.albb_attributes" :key="i" class="cpbe-attribute-row">
                            <span
                              class="gx-cloud__input cpbe-attribute-name"
                              :title="item.attributeName">
                              {{ item.attributeName }}
                            </span>
                            <input
                              v-model="item.value"
                              class="gx-cloud__input cpbe-attribute-value"
                              placeholder="属性值"
                              @input="markCloudEditDirty" />
                            <button type="button" class="cpbe-attribute-remove" @click="removeProductAttribute(i)">
                              <i class="el-icon-delete"></i>
                            </button>
                          </div>
                          <div v-if="!(cloudEditForm.albb_attributes || []).length" class="cpbe-placeholder">
                            暂无商品属性
                          </div>
                        </template>
                      </div>
                      <div v-else-if="section.key === 'detail'" class="gx-cloud__imgs">
                        <div
                          v-for="(url, i) in cloudEditForm.detail_images"
                          :key="i"
                          class="gx-cloud__img gx-cloud__img--lg cpbe-main-image">
                          <img :src="url" alt="" @click="previewImage(url)" />
                          <div class="gx-cloud__img-tools">
                            <button
                              type="button"
                              class="gx-cloud__img-tool"
                              @click="moveCloudEditImage('detail', i, -1)">
                              <i class="el-icon-arrow-left"></i>
                            </button>
                            <button
                              type="button"
                              class="gx-cloud__img-tool"
                              @click="moveCloudEditImage('detail', i, 1)">
                              <i class="el-icon-arrow-right"></i>
                            </button>
                            <button type="button" class="gx-cloud__img-tool" @click="removeCloudEditImage('detail', i)">
                              <i class="el-icon-delete"></i>
                            </button>
                          </div>
                        </div>
                        <button
                          v-if="cloudEditForm.detail_images.length < 50"
                          type="button"
                          class="cpbe-upload-tile"
                          @click="openImageSourceDialog('detail')">
                          <span class="cpbe-upload-plus">＋</span>
                          <span>上传</span>
                        </button>
                        <div v-if="!cloudEditForm.detail_images.length" class="cpbe-placeholder">暂无详情图片</div>
                      </div>
                      <div v-else class="cpbe-placeholder">暂无{{ section.label }}数据</div>
                    </div>
                  </div>
                </div>
                <div v-else class="gx-cloud__empty">请选择左侧商品</div>
              </div>
            </div>
          </div>
          <div class="cpbe-foot cpbe-inline-footer">
            <button class="gx-cloud__btn" @click="closeCloudEdit">关闭</button>
            <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="cloudEditSaving" @click="submitCloudEdit">
              {{ cloudEditSaving ? '保存中...' : '保存更改' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="previewVisible" class="cpbe-image-preview" @click.self="closePreview">
      <button type="button" class="cpbe-image-preview-close" @click="closePreview">×</button>
      <img v-if="!previewError" :src="previewUrl" alt="预览图片" @error="previewError = true" />
      <div v-else class="cpbe-placeholder">图片加载失败</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CloudProductBatchEdit',
  props: {
    visible: Boolean,
    title: { type: String, default: '批量编辑云商品' },
    count: { type: [Number, String], default: 0 }
  },
  data() {
    return {
      sectionOpen: {
        mainImage: true,
        sku: true,
        specSku: false,
        ratioImage: true,
        whiteImage: true,
        detail: true,
        attributes: true,
      },
      extraSections: [
        { key: 'specSku', label: '规格SKU', icon: '📋' },
        { key: 'detail', label: '详情页', icon: '📄' },
        { key: 'ratioImage', label: '3/4图', icon: '📐' },
        { key: 'whiteImage', label: '白底图', icon: '⬜' },
        { key: 'attributes', label: '商品属性', icon: '🏷' },
      ],
      attributesExpanded: false,
      attributesLoading: false,
      attributesLoaded: false,
      attributesData: '',
      newSkuValue: '',
      previewVisible: false,
      previewUrl: '',
      previewError: false,
      distributeRecords: [],
      distributeRecordsLoading: false,
      distributeRecordsError: false,
      distributeRecordsRequestId: null,
      skuValueImageDrafts: {},
      batchSkuCategories: [],
      batchSkuFields: { price: false, stock: false, description: false, code: false },
      batchSkuValues: { price: '', stock: '', description: '', code: '' },
      batchSkuFieldOptions: [
        { key: 'price', label: '价格', type: 'number', placeholder: '批量价格' },
        { key: 'stock', label: '库存', type: 'number', placeholder: '批量库存' },
        // { key: 'description', label: '规格描述', type: 'text', placeholder: '批量描述' },
        { key: 'code', label: 'SKU编码', type: 'text', placeholder: '批量编码' }
      ]
    }
  },
  created() {
    const parent = this.$parent
    if (!parent) return
    const names = [
      'cloudEditMode',
      'cloudEditList',
      'cloudEditSourceList',
      'cloudEditCurrent',
      'cloudEditForm',
      'cloudEditLoading',
      'cloudEditSaving',
      'cloudEditDirty',
      'cloudEditUseRemoteList',
      'cloudEditGroupId',
      'cloudEditChildGroupId',
      'cloudEditChildGroupList',
      'cloudEditSkuStatus',
      'cloudEditAppraisalStatus',
      'cloudEditSkuMarkStatus',
      'cloudEditSkuIsSkuMiss',
      'cloudEditPage',
      'cloudEditPages',
      'cloudEditTotalPages',
      'groupList',
      'skuStatus',
      'skuMarkStatus',
      'appraisal_status',
      'openImageSourceDialog',
      'handleCloudEditFilterGroupChange',
      'handleCloudEditFilterChange',
      'handleCloudEditSelect',
      'loadCloudEditRemoteListPage',
      'markCloudEditDirty',
      'moveCloudEditImage',
      'removeCloudEditImage',
      'clearSkuValueImage',
      'getCloudProductDistributeRecords',
      'syncSkuImagesFromFirstSpec',
      'getSkuAttributesKey',
      'formatSkuAttributes',
      'submitCloudEdit',
      'closeCloudEdit'
    ]
    names.forEach((name) => {
      if (typeof parent[name] === 'function') this[name] = parent[name].bind(parent)
      else
        Object.defineProperty(this, name, {
          configurable: true,
          get: () => parent[name],
          set: (value) => {
            parent[name] = value
          }
        })
    })
    if (this.cloudEditForm && !Array.isArray(this.cloudEditForm.albb_attributes))
      this.$set(
        this.cloudEditForm,
        'albb_attributes',
        this.normalizeProductAttributes(this.cloudEditForm.albb_attributes)
      )
  },
  watch: {
    visible(value) {
      if (value && this.cloudEditForm && this.cloudEditForm.id) {
        this.$nextTick(() => this.loadDistributeRecords(this.cloudEditForm.id))
      }
    },
    cloudEditCurrent: {
      handler() {
        this.attributesLoaded = false
        this.attributesData = ''
        this.attributesLoading = false
        this.resetDistributeRecords()
        if (this.cloudEditForm && !Array.isArray(this.cloudEditForm.albb_attributes))
          this.$set(
            this.cloudEditForm,
            'albb_attributes',
            this.normalizeProductAttributes(this.cloudEditForm.albb_attributes)
          )
      },
      deep: true
    },
    'cloudEditForm.id'() {
      this.resetSkuBatchForm()
      this.resetDistributeRecords()
      if (this.cloudEditForm && !Array.isArray(this.cloudEditForm.albb_attributes))
        this.$set(
          this.cloudEditForm,
          'albb_attributes',
          this.normalizeProductAttributes(this.cloudEditForm.albb_attributes)
        )
    }
  },
  computed: {
    batchSkuCategoryOptions() {
      const values = []
      ;(this.cloudEditForm.skuSpecs || []).forEach((spec) =>
        (spec.values || []).forEach((value) => {
          const text = String(value || '').trim()
          if (text && values.indexOf(text) < 0) values.push(text)
        })
      )
      return values
    },
    canApplySkuBatch() {
      const selected = Object.keys(this.batchSkuFields).filter(
        (key) =>
          this.batchSkuFields[key] &&
          String(this.batchSkuValues[key] == null ? '' : this.batchSkuValues[key]).trim() !== ''
      )
      if (!this.cloudEditForm.skus || !this.cloudEditForm.skus.length || !selected.length) return false
      return selected.every((key) => {
        const value = String(this.batchSkuValues[key] == null ? '' : this.batchSkuValues[key]).trim()
        if (key === 'price') return /^\d+(\.\d{1,2})?$/.test(value) && Number(value) > 0
        if (key === 'stock') return /^\d+$/.test(value)
        return true
      })
    },
    hasSkuAttributeValues() {
      const skus = (this.cloudEditForm && this.cloudEditForm.skus) || []
      return skus.some((sku) => Array.isArray(sku.attributes) && sku.attributes.length > 0)
    }
  },
  methods: {
    formatProductAttributes(value) {
      if (!value) return ''
      if (typeof value === 'string') {
        try {
          return this.formatProductAttributes(JSON.parse(value))
        } catch (e) {
          return value
        }
      }
      if (Array.isArray(value))
        return value
          .map((item) =>
            typeof item === 'object'
              ? `${item.name || item.key || ''}: ${item.value || item.attributeValue || ''}`
              : String(item)
          )
          .join('\n')
      if (typeof value === 'object')
        return Object.keys(value)
          .map((key) => `${key}: ${value[key]}`)
          .join('\n')
      return String(value)
    },
    normalizeProductAttributes(value) {
      if (!value) return []
      if (typeof value === 'string') {
        try {
          return this.normalizeProductAttributes(JSON.parse(value))
        } catch (e) {
          return []
        }
      }
      if (Array.isArray(value))
        return value
          .map((item) => {
            if (!item || typeof item !== 'object') return null
            const attributeName = String(item.attributeName || item.name || item.key || '').trim()
            const attributeValue = String(
              item.value == null ? (item.attributeValue == null ? '' : item.attributeValue) : item.value
            ).trim()
            return attributeName && attributeValue
              ? { ...item, attributeName, value: attributeValue, isCustom: item.isCustom === true }
              : null
          })
          .filter(Boolean)
      if (typeof value === 'object')
        return Object.keys(value)
          .map((key) => ({ attributeName: key, value: String(value[key] == null ? '' : value[key]), isCustom: true }))
          .filter((item) => item.value)
      return []
    },
    removeProductAttribute(index) {
      this.cloudEditForm.albb_attributes.splice(index, 1)
      this.markCloudEditDirty()
    },
    resetSkuBatchForm() {
      this.batchSkuCategories = []
      this.skuValueImageDrafts = {}
      Object.keys(this.batchSkuFields).forEach((key) => {
        this.$set(this.batchSkuFields, key, false)
        this.$set(this.batchSkuValues, key, '')
      })
    },
    getSkuAttributeName(attr) {
      return String(Array.isArray(attr) ? attr[0] : (attr && (attr.key || attr.name)) || '').trim()
    },
    getSkuAttributeValue(attr) {
      return String(Array.isArray(attr) ? attr[1] : (attr && (attr.value || attr.attributeValue)) || '').trim()
    },
    applySkuBatch() {
      if (!this.canApplySkuBatch) return
      const categories = this.batchSkuCategories
      const targets = (this.cloudEditForm.skus || []).filter(
        (sku) =>
          !categories.length ||
          (sku.attributes || []).some((attr) => categories.indexOf(this.getSkuAttributeValue(attr)) >= 0)
      )
      targets.forEach((sku) =>
        Object.keys(this.batchSkuFields).forEach((field) => {
          if (
            this.batchSkuFields[field] &&
            String(this.batchSkuValues[field] == null ? '' : this.batchSkuValues[field]).trim() !== ''
          ) {
            const value =
              field === 'price' || field === 'stock'
                ? Number(this.batchSkuValues[field])
                : String(this.batchSkuValues[field] == null ? '' : this.batchSkuValues[field])
            this.$set(sku, field, value)
          }
        })
      )
      this.markCloudEditDirty()
      this.$nextTick(() => this.$forceUpdate())
    },
    getSkuPreviewImage(sku) {
      if (sku && sku.image_url) return sku.image_url
      const attrs = this.normalizeSkuAttributes ? this.normalizeSkuAttributes(sku && sku.attributes) : []
      const value = attrs[0] && attrs[0][1]
      return value && this.cloudEditForm.skuValueImages ? this.cloudEditForm.skuValueImages[value] : ''
    },
    getSkuValueImage(specIndex, valueIndex, value) {
      return (
        this.skuValueImageDrafts[`${specIndex}:${valueIndex}`] || (this.cloudEditForm.skuValueImages || {})[value] || ''
      )
    },
    addSkuSpecValue() {
      const value = String(this.newSkuValue || '').trim()
      const spec = this.cloudEditForm.skuSpecs && this.cloudEditForm.skuSpecs[0]
      if (!value || !spec || (spec.values || []).indexOf(value) >= 0) return
      this.$set(spec, 'values', (spec.values || []).concat(value))
      if (!this.cloudEditForm.skuValueImages) this.$set(this.cloudEditForm, 'skuValueImages', {})
      this.$set(this.cloudEditForm.skuValueImages, value, '')
      this.syncSkuRows()
      this.newSkuValue = ''
      this.markCloudEditDirty()
    },
    addSkuValueForSpec(index) {
      const spec = this.cloudEditForm.skuSpecs[index]
      if (spec && !(spec.values || []).some((v) => !String(v).trim())) {
        this.$set(spec, 'values', (spec.values || []).concat(''))
        this.markCloudEditDirty()
      }
    },
    handleSkuValueChange(specIndex, valueIndex, rawValue) {
      const spec = this.cloudEditForm.skuSpecs[specIndex]
      if (!spec) return
      const oldValue = String(spec.values[valueIndex] || '')
      const value = String(rawValue || '').trim()
      const draftKey = `${specIndex}:${valueIndex}`
      const draftImage = this.skuValueImageDrafts[draftKey] || ''
      if (!value) {
        this.$set(spec.values, valueIndex, '')
        const image = this.cloudEditForm.skuValueImages && this.cloudEditForm.skuValueImages[oldValue]
        if (image) this.$set(this.skuValueImageDrafts, `${specIndex}:${valueIndex}`, image)
        this.markCloudEditDirty()
        return
      }
      if (spec.values.some((v, i) => i !== valueIndex && String(v).trim() === value)) {
        this.$nextTick(() => this.$forceUpdate())
        return
      }
      this.$set(spec.values, valueIndex, value)
      if (!this.cloudEditForm.skuValueImages) this.$set(this.cloudEditForm, 'skuValueImages', {})
      if (draftImage) {
        this.$set(this.cloudEditForm.skuValueImages, value, draftImage)
      } else if (oldValue && Object.prototype.hasOwnProperty.call(this.cloudEditForm.skuValueImages, oldValue)) {
        this.$set(this.cloudEditForm.skuValueImages, value, this.cloudEditForm.skuValueImages[oldValue])
        this.$delete(this.cloudEditForm.skuValueImages, oldValue)
      }
      this.$delete(this.skuValueImageDrafts, draftKey)
      if (oldValue !== value && Object.prototype.hasOwnProperty.call(this.cloudEditForm.skuValueImages, oldValue)) {
        this.$set(this.cloudEditForm.skuValueImages, value, this.cloudEditForm.skuValueImages[oldValue])
        this.$delete(this.cloudEditForm.skuValueImages, oldValue)
      }
      ;(this.cloudEditForm.skus || []).forEach((sku) =>
        (sku.attributes || []).forEach((attr) => {
          if (Array.isArray(attr) && String(attr[1]) === oldValue) this.$set(attr, 1, value)
          else if (!Array.isArray(attr) && String(attr.value) === oldValue) this.$set(attr, 'value', value)
        })
      )
      this.syncSkuRows()
      this.markCloudEditDirty()
    },
    getSpecSkuValue(spec, field) {
      const name = spec && (spec.name || spec.key)
      const sku = (this.cloudEditForm.skus || []).find(
        (item) => this.formatSkuAttributes(item.attributes).indexOf(name) >= 0
      )
      return sku ? sku[field] : ''
    },
    updateSpecSkuValue(spec, field, value) {
      const name = spec && (spec.name || spec.key)
      const sku = (this.cloudEditForm.skus || []).find(
        (item) => this.formatSkuAttributes(item.attributes).indexOf(name) >= 0
      )
      if (sku) {
        this.$set(sku, field, value)
        this.markCloudEditDirty()
      }
    },
    removeSkuSpecValue(specIndex, valueIndex) {
      const spec = this.cloudEditForm.skuSpecs && this.cloudEditForm.skuSpecs[specIndex]
      if (!spec) return
      const value = spec.values[valueIndex]
      spec.values.splice(valueIndex, 1)
      if (specIndex === 0 && this.cloudEditForm.skuValueImages) this.$delete(this.cloudEditForm.skuValueImages, value)
      this.syncSkuRows()
      this.markCloudEditDirty()
    },
    syncSkuRows() {
      const specs = (this.cloudEditForm.skuSpecs || [])
        .map((spec) => ({
          key: spec.name || spec.key || '规格',
          values: (spec.values || []).map((value) => String(value || '').trim()).filter(Boolean)
        }))
        .filter((spec) => spec.values.length)
      if (!specs.length) return this.$set(this.cloudEditForm, 'skus', [])
      const previous = {}
      ;(this.cloudEditForm.skus || []).forEach((sku) => {
        previous[this.getSkuAttributesKey(sku.attributes)] = sku
      })
      const rows = []
      const build = (index, attrs) => {
        if (index === specs.length) {
          const attributes = attrs.map((item) => [item.key, item.value])
          const key = this.getSkuAttributesKey(attributes)
          const old = previous[key]
          const firstValue = attributes[0] && attributes[0][1]
          rows.push(
            old || {
              attributes,
              price: '',
              stock: 999,
              description: '',
              code: '',
              enabled: true,
              image_url: (this.cloudEditForm.skuValueImages || {})[firstValue] || ''
            }
          )
          return
        }
        specs[index].values.forEach((value) => build(index + 1, attrs.concat({ key: specs[index].key, value })))
      }
      build(0, [])
      this.$set(this.cloudEditForm, 'skus', rows)
      if (typeof this.syncSkuImagesFromFirstSpec === 'function') this.syncSkuImagesFromFirstSpec()
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewError = false
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
      this.previewUrl = ''
      this.previewError = false
    },
    resetDistributeRecords() {
      this.distributeRecords = []
      this.distributeRecordsLoading = false
      this.distributeRecordsError = false
      this.distributeRecordsRequestId = null
    },
    loadDistributeRecords(id) {
      if (id && this.distributeRecordsRequestId === id) return
      this.resetDistributeRecords()
      if (!id || typeof this.getCloudProductDistributeRecords !== 'function') return
      this.distributeRecordsRequestId = id
      this.distributeRecordsLoading = true
      this.getCloudProductDistributeRecords({
        id,
        success: (res) => {
          if (this.distributeRecordsRequestId !== id) return
          const data = res && (res.data || res)
          const list = Array.isArray(data) ? data : data && (data.list || data.records)
          this.distributeRecords = Array.isArray(list) ? list.slice(0, 1) : []
          this.distributeRecordsLoading = false
        },
        error: () => {
          if (this.distributeRecordsRequestId !== id) return
          this.distributeRecordsError = true
          this.distributeRecordsLoading = false
        }
      })
    },
    toggleSection(key) {
      this.$set(this.sectionOpen, key, !this.sectionOpen[key])
      if (key === 'attributes' && this.sectionOpen.attributes && !this.attributesLoaded) this.loadAttributes()
    },
    loadAttributes() {
      if (this.attributesLoading || this.attributesLoaded || !this.cloudEditForm || !this.cloudEditForm.id) return
      this.attributesLoading = true
      const action = this.$store && this.$store.dispatch
      if (!action) {
        this.attributesLoading = false
        return
      }
      if (!this.$store._actions || !this.$store._actions.getCloudProductAttributes) {
        this.$set(
          this.cloudEditForm,
          'albb_attributes',
          this.normalizeProductAttributes(this.cloudEditForm.albb_attributes)
        )
        this.attributesData = ''
        this.attributesLoaded = true
        this.attributesLoading = false
        return
      }
      action
        .call(this.$store, 'getCloudProductAttributes', { id: this.cloudEditForm.id })
        .then((res) => {
          const data = res && (res.data || res)
          this.$set(this.cloudEditForm, 'albb_attributes', this.normalizeProductAttributes(data))
          this.attributesData = ''
          this.attributesLoaded = true
        })
        .catch(() => {})
        .finally(() => {
          this.attributesLoading = false
        })
    },
    getDistributeRecordType(record) {
      if (record && (Number(record.platform_ban_status) === 1 || /封禁/.test(record.platform_status_text || '')))
        return 'ban'
      if (
        record &&
        (/驳回/.test(record.distribute_status_text || record.platform_status_text || '') ||
          Number(record.distribute_status) === 5)
      )
        return 'review'
      if (
        record &&
        (Number(record.distribute_status) === 3 || Number(record.distribute_status) === 5 || record.error_msg)
      )
        return 'fail'
      if (record && Number(record.distribute_status) === 4) return 'success'
      return 'default'
    },
    getDistributeRecordIcon(record) {
      return { success: '✅', fail: '⚠️', review: '🚫', ban: '🔒', default: 'ℹ️' }[this.getDistributeRecordType(record)]
    },
    close() {
      if (this.closeCloudEdit) this.closeCloudEdit()
      else this.$emit('close')
    },
    getShortTitleByteLength(str) {
      if (!str) return 0
      let length = 0
      for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i)
        if (code >= 0x4e00 && code <= 0x9fff) {
          length += 1
        } else {
          length += 0.5
        }
      }
      return length
    },
    handleShortTitleInput(e) {
      const value = e.target.value
      let length = 0
      let validLength = 0
      for (let i = 0; i < value.length; i++) {
        const code = value.charCodeAt(i)
        const charLength = code >= 0x4e00 && code <= 0x9fff ? 1 : 0.5
        if (length + charLength <= 12) {
          length += charLength
          validLength = i + 1
        } else {
          break
        }
      }
      if (validLength < value.length) {
        this.$set(this.cloudEditForm, 'short_title', value.substring(0, validLength))
        this.$nextTick(() => this.$forceUpdate())
      }
      this.markCloudEditDirty()
    }
  }
}
</script>
<style scoped>
.cpbe-modal {
  position: fixed;
  font-family: 'Noto Sans SC', sans-serif;
  inset: 0;
  z-index: 900;
  background: rgba(0, 0, 0, 0.42);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.cpbe-box {
  width: 90%;
  height: 90%;
  border: 2px solid #e0e0ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 56px rgba(0, 0, 0, 0.22);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cpbe-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #f5f0e8;
  border-bottom: 1px solid #e0e0ec;
  flex-shrink: 0;
}

.cpbe-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cpbe-accent {
  width: 3px;
  height: 15px;
  background: #c8443c;
}

.cpbe-title {
  font: 600 15px 'Noto Sans SC', sans-serif;
  color: rgb(26, 26, 46);
}

.cpbe-count {
  font: 11px monospace;
  color: #999;
}

.cpbe-close {
  width: 26px;
  height: 26px;
  border: 2px solid #e0e0ec;
  border-radius: 5px;
  background: #fff;
  font-size: 20px;
  cursor: pointer;
}

.cpbe-section {
  margin-bottom: 8px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 8px;
  overflow: hidden;
  background: rgb(250, 250, 250);
}

.cpbe-section--open {
  border: 1.5px solid rgb(255, 205, 210);
}

.cpbe-section-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 0;
  background: rgb(250, 250, 250);
  color: rgb(26, 26, 46);
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  user-select: none;
}

.cpbe-section-icon {
  flex: 0 0 auto;
  width: 18px;
  font-size: 14px;
  line-height: 1;
  color: initial;
  background: transparent;
}

.cpbe-section:not(.cpbe-section--open) .cpbe-section-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  background: rgb(250, 250, 250);
  color: rgb(26, 26, 46);
  cursor: pointer;
  user-select: none;
  /* border: 0.5px solid rgb(224, 224, 236); */
}

.cpbe-section--open .cpbe-section-head {
  background: #fff5f5;
  color: rgb(200, 68, 60);
  border-bottom: 1px solid rgb(224, 224, 236);
}

.cpbe-section-arrow {
  margin-left: auto;
  margin-top: 0px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: transform 0.15s;
}

.cpbe-section--open .cpbe-section-arrow {
  transform: rotate(180deg);
}

.cpbe-section-body {
  padding: 10px 12px;
  background: #fff;
}

.cpbe-placeholder {
  padding: 22px 10px;
  text-align: center;
  color: #999;
  font-size: 12px;
}

.cpbe-content {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.cpbe-main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.cpbe-body {
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.cpbe-body .gx-cloud__edit-box {
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 0;
}

.cpbe-body .gx-cloud__edit-left {
  width: 15%;
  min-width: 280px;
  flex-shrink: 0;
  max-height: none;
  overflow: hidden;
  border: 0;
  border-right: 1px solid #e0e0ec;
  border-radius: 0;
  background: #fafafa;
}

.cpbe-body .gx-cloud__edit-products {
  overflow-y: auto;
}

.cpbe-body .gx-cloud__edit-right {
  flex: 1;
  min-width: 0;
  max-height: none;
  overflow-y: auto;
  border: 0;
  border-radius: 0;
  padding: 14px 18px;
}

.cpbe-modal .cpbe-distribute-records {
  position: sticky;
  top: -14px;
  z-index: 3;
  display: grid;
  gap: 5px;
  padding: 0 0 8px;
  background: #fafafa;
}

.cpbe-modal .cpbe-distribute-record {
  padding: 7px 9px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
  color: #333;
}

.cpbe-modal .cpbe-distribute-record:last-child {
  margin-bottom: 0;
}

.cpbe-modal .cpbe-distribute-record.is-success {
  background: #f0f9eb;
  border-color: #b3d8a8;
  color: rgb(25 167 72);
}

.cpbe-modal .cpbe-distribute-record.is-fail {
  background: rgb(255, 245, 245);
  border-color: rgb(200, 68, 60);
  color: rgb(200, 68, 60);
}

.cpbe-modal .cpbe-distribute-record.is-review {
  background: rgb(255 247 230);
  border-color: rgb(255, 213, 145);
  color: rgb(251, 146, 60);
}

.cpbe-modal .cpbe-distribute-record.is-ban {
  background: #f0f0f0;
  border-color: #c8c8c8;
  color: #555;
}

.cpbe-modal .cpbe-distribute-record-status {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 700;
}

.cpbe-modal .cpbe-distribute-record-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 4px 8px;
}

.cpbe-modal .cpbe-distribute-record-grid span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpbe-modal .cpbe-distribute-record-reason {
  margin-top: 4px;
  white-space: normal;
  word-break: break-all;
}

.cpbe-modal .cpbe-distribute-records-state {
  padding: 5px;
  color: #999;
  font-size: 11px;
  text-align: center;
}

.cpbe-body .gx-cloud__img--lg {
  width: 108px;
  height: 108px;
}

.cpbe-body .gx-cloud__img--lg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cpbe-body .gx-cloud__imgs {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.cpbe-body .gx-cloud__imgs > .gx-cloud__edit-imgbar {
  flex: 0 0 100%;
  margin-bottom: 0;
}

.cpbe-modal .cpbe-upload-tile {
  width: 108px;
  height: 108px;
  flex: 0 0 108px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  background: #fafafa;
  color: #999;
  font-size: 11px;
  cursor: pointer;
}

.cpbe-modal .cpbe-upload-tile:hover {
  border-color: #c8443c;
  background: #fff5f5;
  color: #c8443c;
}

.cpbe-modal .cpbe-upload-plus {
  font-size: 22px;
  line-height: 1;
  font-weight: 300;
}

.cpbe-image-preview {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: rgba(0, 0, 0, 0.72);
}

.cpbe-image-preview img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 6px;
}

.cpbe-image-preview-close {
  position: absolute;
  top: 24px;
  right: 28px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: #666;
  font-size: 22px;
  cursor: pointer;
}

.cpbe-modal .cpbe-main-image {
  position: relative;
  width: 108px;
  height: 108px;
  flex: 0 0 108px;
  box-sizing: border-box;
  padding: 2px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 6px;
  background: #f5f5f5;
  overflow: hidden;
}

.cpbe-modal .cpbe-main-image > img {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  object-fit: cover;
  object-position: center;
  /* border-radius: 5px; */
}

.cpbe-modal .cpbe-main-image .gx-cloud__img-tools {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 26px;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  z-index: 1;
}

.cpbe-modal .cpbe-main-image .gx-cloud__img-tool {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 26px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
}

.cpbe-modal .cpbe-main-image .gx-cloud__img-tool:hover {
  background: rgba(255, 255, 255, 0.2);
}

.cpbe-inline-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 11px 18px;
  background: #f5f0e8;
  border-top: 1px solid #e0e0ec;
  flex-shrink: 0;
}

.cpbe-modal .gx-cloud__modal-body {
  padding: 0;
  overflow: hidden;
}

.cpbe-modal .gx-cloud__field {
  margin-bottom: 14px;
}

.cpbe-modal .gx-cloud__label {
  display: block;
  font-size: 12px;
  color: #4a4a6a;
  margin-bottom: 6px;
}

.cpbe-modal .gx-cloud__req {
  color: #f56c6c;
  font-style: normal;
}

.cpbe-modal .gx-cloud__input {
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 7px;
  color: rgb(26, 26, 46);
  outline: none;
  font-size: 13px;
}

.cpbe-modal .gx-cloud__input--full {
  width: 100%;
  padding: 8px 10px;
}

.cpbe-modal .gx-cloud__input:focus {
  border-color: #c8443c;
}

.cpbe-modal .gx-cloud__tips {
  margin-top: 4px;
  color: #f56c6c;
  font-size: 11px;
  line-height: 1.7;
}

.cpbe-modal .gx-cloud__dim {
  color: #999;
  font-size: 11px;
}

.cpbe-modal .gx-cloud__invalid {
  color: #f56c6c !important;
}

.cpbe-modal .gx-cloud__edit-left {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.cpbe-modal .gx-cloud__sku-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.cpbe-modal .gx-cloud__select {
  height: 28px;
  padding: 0 8px;
  border: 1px solid #e1e5ee;
  border-radius: 4px;
  background: #fff;
  color: rgb(26, 26, 46);
  font-size: 12px;
  width: calc(50% - 3px);
}

.cpbe-modal .gx-cloud__edit-count {
  font-size: 11px;
  color: #6a6a8a;
  margin-bottom: 8px;
}

.cpbe-modal .gx-cloud__edit-products {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
}

.cpbe-modal .gx-cloud__edit-item {
  display: flex;
  gap: 8px;
  padding: 8px;
  border: 1px solid #e1e5ee;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.cpbe-modal .gx-cloud__edit-item--on {
  border-color: #ffccc7;
  background: #fff5f4;
}

.cpbe-modal .gx-cloud__edit-item-body {
  min-width: 0;
  flex: 1;
}

.cpbe-modal .gx-cloud__edit-item-title {
  font-size: 12px;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgb(26, 26, 46);
}

.cpbe-modal .gx-cloud__edit-item-meta {
  display: flex;
  gap: 8px;
  margin-top: 3px;
  font-size: 11px;
}

.cpbe-modal .gx-cloud__sku-thumb {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  overflow: hidden;
  border-radius: 6px;
  background: #f5f5f5;
}

.cpbe-modal .gx-cloud__sku-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cpbe-modal .gx-cloud__sku-specs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.cpbe-sku-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  margin-bottom: 8px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
}

.cpbe-sku-name {
  width: 50px;
  color: #666;
  font-size: 12px;
  flex: 0 0 50px;
}

.cpbe-sku-values {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  flex: 1;
  min-width: 0;
}

.cpbe-sku-add-btn {
  padding: 3px 7px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #999;
  font-size: 11px;
  cursor: pointer;
}

.cpbe-sku-label {
  color: #999;
  font-size: 11px;
  white-space: nowrap;
}

.cpbe-sku-num {
  width: 58px;
  padding: 5px 6px;
}

.cpbe-sku-value-wrap {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.cpbe-modal .cpbe-sku-value-input {
  width: 135px;
  min-width: 96px;
  padding: 4px 6px;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  color: #c8443c;
  font-size: 11px;
}

.cpbe-modal .cpbe-sku-value-remove {
  padding: 2px;
  border: 0;
  background: transparent;
  color: #999;
  cursor: pointer;
}

.cpbe-modal .cpbe-sku-value-remove:hover {
  color: #c8443c;
}

.cpbe-modal .cpbe-sku-value-image {
  position: relative;
  display: inline-flex;
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #f5f5f5;
}

.cpbe-modal .cpbe-sku-value-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.cpbe-modal .cpbe-sku-value-image-empty {
  color: #aaa;
  font-size: 20px;
}

.cpbe-modal .cpbe-sku-value-image-tools {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: rgba(0, 0, 0, 0.55);
}

.cpbe-modal .cpbe-sku-value-image-tools button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-size: 11px;
}

.cpbe-specsku-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cpbe-modal .cpbe-specsku-batch {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  padding: 10px;
  border: 1px solid #e0e0ec;
  background: #fafafa;
}

.cpbe-modal .cpbe-attributes-editor {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  align-items: start;
}

.cpbe-modal .cpbe-attribute-row {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 6px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fafafa;
}

.cpbe-modal .cpbe-attribute-name,
.cpbe-modal .cpbe-attribute-value {
  box-sizing: border-box;
  height: 22px;
  padding: 4px 6px;
  border: 1px solid #ffccc7;
  border-radius: 0;
  color: #c8443c;
  font-size: 11px;
  background: #FFFFFF;
}

.cpbe-modal .cpbe-attribute-name {
  width: 76px;
  flex: 0 0 76px;
  overflow: hidden;
  line-height: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #d4d4d4;
}

.cpbe-modal .cpbe-attribute-value {
  width: auto;
  flex: 1 1 auto;
  min-width: 0;
}

.cpbe-modal .cpbe-attribute-value:focus {
  border-color: #c8443c;
  outline: none;
}

.cpbe-modal .cpbe-attribute-remove {
  padding: 4px;
  border: 0;
  background: transparent;
  color: #999;
  cursor: pointer;
}

.cpbe-modal .cpbe-attribute-remove:hover {
  color: #c8443c;
}

.cpbe-modal .cpbe-attributes-editor > .cpbe-placeholder {
  grid-column: 1 / -1;
}

.cpbe-modal .cpbe-batch-caption {
  color: #555;
  font-size: 12px;
  font-weight: 600;
}

.cpbe-modal .cpbe-batch-category-select {
  width: 140px;
  font-size: 11px;
}

.cpbe-modal .cpbe-batch-category-select .el-input__inner {
  height: 28px;
  padding: 0 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  color: #333;
  font-size: 11px;
}

.cpbe-modal .cpbe-batch-category-select .el-select__tags {
  max-width: calc(100% - 36px);
  overflow: hidden;
  white-space: nowrap;
}

.cpbe-modal .cpbe-batch-category-select .el-tag {
  max-width: 72px;
  height: 20px;
  line-height: 18px;
  margin: 2px 3px 2px 0;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
}

.cpbe-modal >>> .cpbe-batch-category-select .el-select__tags {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 24px;
  overflow: hidden;
}

.cpbe-modal >>> .cpbe-batch-category-select .el-tag {
  flex: 0 0 auto;
}

.cpbe-modal .cpbe-batch-field {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.cpbe-modal .cpbe-batch-field .gx-cloud__input {
  width: 120px;
  border-radius: 4px;
  height: 24px;
  padding: 0px 8px;
}

.cpbe-modal .cpbe-batch-apply {
  padding: 5px 9px;
  font-size: 12px;
  border: 1px solid #c8443c;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  cursor: pointer;
}

.cpbe-modal .cpbe-batch-apply:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cpbe-modal .cpbe-specsku-fields-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.cpbe-modal .cpbe-specsku-fields-row label {
  flex: 0 0 auto;
  color: #666;
  font-size: 12px;
}

.cpbe-modal .cpbe-specsku-text-row .gx-cloud__input {
  flex: 0 1 120px;
  min-width: 120px;
  width: 120px;
}

.cpbe-modal .cpbe-specsku-description,
.cpbe-modal .cpbe-specsku-code {
  box-sizing: border-box;
  height: 22px;
  padding: 0 6px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 4px;
  outline: none;
  font-size: 10px;
  border-radius: 4px;
}

.cpbe-modal .cpbe-specsku-text-row .cpbe-specsku-description {
  flex: 0 1 180px;
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.cpbe-modal .cpbe-specsku-text-row .cpbe-specsku-code {
  flex: 0 0 120px;
  width: 120px;
  min-width: 120px;
  border-radius: 4px;
}

.cpbe-modal .cpbe-specsku-description {
  color: rgb(26, 26, 46);
  font-family: 'Noto Sans SC', sans-serif;
}

.cpbe-modal .cpbe-specsku-code {
  flex: 0 0 240px;
  width: 240px;
  min-width: 240px;
  color: rgb(153, 153, 153);
  font-family: 'JetBrains Mono', monospace;
}

.cpbe-modal .cpbe-specsku-description:focus,
.cpbe-modal .cpbe-specsku-code:focus {
  border-color: rgb(200, 68, 60);
}

.cpbe-modal .cpbe-specsku-num {
  width: 78px;
}

.cpbe-modal .cpbe-specsku-card {
  display: flex;
  align-items: stretch;
  gap: 10px;
  padding: 10px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: rgb(250, 250, 250);
}

.cpbe-modal .cpbe-specsku-index {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  color: #999;
  font-size: 13px;
}

.cpbe-modal .cpbe-specsku-info {
  display: flex;
  flex: 1;
  min-width: 0;
  /* min-height: 108px; */
  flex-direction: column;
  gap: 15px;
}

.cpbe-modal .cpbe-specsku-info strong {
  color: #1a1a2e;
  font-size: 13px;
}

.cpbe-modal .cpbe-specsku-info .gx-cloud__input {
  width: 120px;
  border-radius: 4px;
  height: 24px;
  padding: 0px 8px;
}

.cpbe-modal .cpbe-specsku-info .cpbe-specsku-code {
  flex: 0 0 240px;
  width: 240px;
  min-width: 240px;
}

.cpbe-sku-add {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.cpbe-sku-add .gx-cloud__input {
  flex: 1;
  padding: 6px 8px;
  width: 120px;
}

.cpbe-sku-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.cpbe-modal .cpbe-sku-preview-wrap {
  display: flex;
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #f5f5f5;
}

.cpbe-sku-preview-empty {
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #bbb;
  background: #f5f5f5;
  border-radius: 4px;
}

.cpbe-modal .gx-cloud__table--plain table {
  table-layout: fixed;
}

.cpbe-modal .gx-cloud__table--plain th:first-child,
.cpbe-modal .gx-cloud__table--plain td:first-child {
  width: 56px;
}

.cpbe-modal .gx-cloud__table--plain th:nth-child(3),
.cpbe-modal .gx-cloud__table--plain td:nth-child(3),
.cpbe-modal .gx-cloud__table--plain th:nth-child(4),
.cpbe-modal .gx-cloud__table--plain td:nth-child(4) {
  width: 88px;
}

.cpbe-modal .gx-cloud__sku-spec-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.cpbe-modal .gx-cloud__sku-spec-name {
  font-size: 12px;
  font-weight: 600;
  color: rgb(26, 26, 46);
}

.cpbe-modal .gx-cloud__sku-spec-tag {
  padding: 3px 10px;
  border-radius: 12px;
  background: #fff1f0;
  border: 1px solid #ffccc7;
  font-size: 11px;
  color: #c8443c;
  cursor: pointer;
}

.cpbe-modal .gx-cloud__sku-val-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 6px;
}

.cpbe-modal .gx-cloud__sku-val-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid #e1e5ee;
  border-radius: 8px;
  font-size: 11px;
}

.cpbe-modal .gx-cloud__sku-val-thumb {
  width: 28px;
  height: 28px;
  border-radius: 5px;
  object-fit: cover;
}

.cpbe-modal .gx-cloud__table {
  width: 100%;
  overflow: auto;
}

.cpbe-modal .gx-cloud__table table {
  width: 100%;
  border-collapse: collapse;
}

.cpbe-modal .gx-cloud__table th,
.cpbe-modal .gx-cloud__table td {
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  font-size: 12px;
}

.cpbe-modal .gx-cloud__table th {
  background: #f5f0e8;
  color: #666;
}

.cpbe-modal .gx-cloud__empty {
  padding: 24px;
  text-align: center;
  color: #999;
  font-size: 12px;
}

.cpbe-modal .gx-cloud__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  margin-top: 6px;
  border-top: 1px solid #e1e5ee;
  flex-shrink: 0;
}

.cpbe-modal .gx-cloud__pager-left,
.cpbe-modal .gx-cloud__pager-btns {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cpbe-modal .gx-cloud__pager-total {
  font-size: 11px;
  color: #6a6a8a;
  white-space: nowrap;
}

.cpbe-modal .gx-cloud__page {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #e1e5ee;
  border-radius: 5px;
  background: #fff;
  color: #6a6a8a;
  font-size: 11px;
  cursor: pointer;
}

.cpbe-modal .gx-cloud__page:hover:not(:disabled) {
  border-color: #c8443c;
  color: #c8443c;
  background: #fff5f5;
}

.cpbe-modal .gx-cloud__page--on {
  border-color: #c8443c;
  background: #c8443c;
  color: #fff;
}

.cpbe-modal .gx-cloud__page:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.cpbe-modal .gx-cloud__btn {
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}

.cpbe-modal .gx-cloud__btn:hover:not(:disabled) {
  border-color: #c8443c;
  color: #c8443c;
  background: #fff5f5;
}

.cpbe-modal .gx-cloud__btn--primary {
  border-color: transparent;
  background: linear-gradient(135deg, #ff4d4f, #ff7875);
  color: #fff;
  font-weight: 600;
}

.cpbe-modal .gx-cloud__btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #d9363e, #ff4d4f);
  color: #fff;
}

.cpbe-modal .gx-cloud__btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.cpbe-modal .gx-cloud__field {
  padding: 12px 14px;
  border: 1px solid #e1e5ee;
  border-radius: 8px;
  background: #fff;
}

.cpbe-modal .gx-cloud__field + .gx-cloud__field {
  margin-top: 10px;
}

.cpbe-modal .gx-cloud__edit-right {
  background: #fafafa;
}

.cpbe-modal .gx-cloud__edit-imgbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.cpbe-modal .gx-cloud__edit-imgbar .gx-cloud__btn {
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
}

@media (max-width: 900px) {
  .cpbe-modal .cpbe-attributes-editor {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .cpbe-modal .cpbe-specsku-text-row .cpbe-specsku-description {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    max-width: none;
  }

  .cpbe-box {
    width: 100vw;
    min-width: 0;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }

  .cpbe-body .gx-cloud__edit-box {
    flex-direction: column;
  }

  .cpbe-body .gx-cloud__edit-left {
    width: 100%;
    min-width: 0;
    max-height: 320px;
    border-right: 0;
    border-bottom: 1px solid #e0e0ec;
  }
}

@media (max-width: 560px) {
  .cpbe-modal .cpbe-attributes-editor {
    grid-template-columns: 1fr;
  }
}
</style>
